import { setQueriesDataFromKey } from '@pba/react-query';
import { useCallback } from 'react';
import { useQueryClient } from '#react-query';
import { type ChatroomsInfiniteQueryData, getChatroomsInfiniteQueryKey } from '../use-get-chatrooms';
import { useUpdateChatroomStatsInCache } from './useUpdateChatroomStatsInCache';

export const useDeleteChatroomFromCache = () => {
  const queryClient = useQueryClient();
  const { refetchChatroomStats } = useUpdateChatroomStatsInCache();

  return useCallback(
    async ({ chatroomId }: { chatroomId: string }) => {
      setQueriesDataFromKey<ChatroomsInfiniteQueryData>(queryClient, getChatroomsInfiniteQueryKey({}), (data) => {
        if (!data) {
          return {
            pageParams: [],
            pages: [],
          };
        }

        const updatedPages = data.pages.map((page) => {
          const chatroomIndex = page.findIndex((chatroom) => chatroom?._id === chatroomId);
          if (chatroomIndex !== -1) {
            const updatedPage = [...page];
            updatedPage[chatroomIndex] = null;
            return updatedPage;
          }

          return page;
        });

        return {
          pageParams: data.pageParams,
          pages: updatedPages,
        };
      });

      await refetchChatroomStats();
    },
    [queryClient, refetchChatroomStats],
  );
};
